<!-- Spinner while catalog is being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading technology items. Click below try again.
    <button hc-button size="lg" (click)="loadTechnology()">Reload Technology</button>
</div>

<div class="admin-product-catalog-table-container" [hidden]="loadError || loading">
    <h2>
        <span>
            <hc-icon fontSet="fa" fontIcon="fa-laptop"></hc-icon>
            Technology
        </span>
        <div>
            <button hc-button routerLink="/admin/technology/editor">Add Technology</button>
            <button hc-button buttonStyle="minimal" id="menu-button" [hcPop]="editMenu">
                <hc-icon fontSet="fa" fontIcon="fa-ellipsis-v"></hc-icon>
            </button>
            <hc-pop #editMenu [autoCloseOnContentClick]="true" [showArrow]="false" horizontalAlign="end">
                <div hcMenu>
                    <button hcMenuItem (click)="openStringEditor('Type')">
                        <span hcMenuText><hc-icon hcMenuIcon fontSet="fa" fontIcon="fa-pencil"></hc-icon>Edit technology types</span>
                    </button>
                </div>
            </hc-pop>
        </div>
    </h2>
    <div class="admin-product-catalog-control-bar">
        <div class="admin-product-catalog-filters">
            <div class="filter-dropdown" title="Filter by type">
                <label for="productLine">Type</label>
                <button hc-button buttonStyle="link-inline" id="type" [hcPop]="filtermenu"
                    (click)="storeFilterData('type')" [context]="typeFilters">
                    <span class="value hc-text-ellipsis filter-dropdown-length">{{ typeText }}</span>
                    <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                </button>
            </div>
            <div class="filter-dropdown" title="Filter by product line">
                <label for="productLine">Product Line</label>
                <button hc-button buttonStyle="link-inline" id="productLine" [hcPop]="filtermenu"
                    (click)="storeFilterData('productLine')" [context]="productLineFilters">
                    <span class="value hc-text-ellipsis filter-dropdown-length">{{ productLineText }}</span>
                    <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                </button>
            </div>
            <div class="filter-dropdown" title="Filter by product status">
                <label for="productStatus">Status</label>
                <button hc-button buttonStyle="link-inline" id="productStatus" [hcPop]="filtermenu"
                    (click)="storeFilterData('status')" [context]="statusFilters">
                    <span class="value hc-text-ellipsis filter-dropdown-length">{{ statusText }}</span>
                    <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                </button>
            </div>
            <div class="filter-dropdown" title="Filter by publish status">
                <label for="publishedStatus">Publish Status</label>
                <button hc-button buttonStyle="link-inline" id="publishedStatus" [hcPop]="filtermenu"
                    (click)="storeFilterData('published')" [context]="publishStatusFilters">
                    <span class="value hc-text-ellipsis filter-dropdown-length">{{ publishStatusText }}</span>
                    <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                </button>
            </div>
            <hc-pop #filtermenu scrollStrategy="close" (opened)="filterSelections = $event">
                <filter-popover [filterData]="filterData" [setVals]="filterSelections" (close)="filtermenu.close()"
                    (filterChecked)="storeFilterArray($event)"></filter-popover>
            </hc-pop>
        </div>
        <div class="control-bar-right">
            <hc-search-bar #searchbar placeholder="Search technology items" (triggerSearch)="applySearchFilter($event)"
                class="admin-product-catalog-search"></hc-search-bar>
        </div>
    </div>
    <table hc-table [borders]="false" class="admin-product-catalog-table" [dataSource]="dataSource" hcSort>
        <!-- ID Column -->
        <ng-container hcColumnDef="item">
            <th hc-index-cell *hcHeaderCellDef hc-sort-header id="item">ID</th>
            <td hc-index-cell *hcCellDef="let element" routerLink="/admin/technology/editor" [queryParams]="{id: element.technologyID}">{{ element.item }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container hcColumnDef="name">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
            <td hc-cell *hcCellDef="let element"routerLink="/admin/technology/editor" [queryParams]="{id: element.technologyID}">{{ element.name }}</td>
        </ng-container>

        <!-- Type Column -->
        <ng-container hcColumnDef="type">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="typeHeader">Type</th>
            <td hc-cell *hcCellDef="let element" routerLink="/admin/technology/editor" [queryParams]="{id: element.technologyID}">{{ element.type }}</td>
        </ng-container>

        <!-- Product Line Column -->
        <ng-container hcColumnDef="productLine">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="productLineHeader">Product Line</th>
            <td hc-cell *hcCellDef="let element" routerLink="/admin/technology/editor" [queryParams]="{id: element.technologyID}">{{ element.productLine }}</td>
        </ng-container>

        <!-- Status Column -->
        <ng-container hcColumnDef="status">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="statusHeader">Status</th>
            <td hc-cell *hcCellDef="let element" routerLink="/admin/technology/editor" [queryParams]="{id: element.technologyID}">{{ element.status }}</td>
        </ng-container>

        <!-- SLA Column -->
        <ng-container hcColumnDef="sla">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="slaHeader">SLA</th>
            <td hc-cell *hcCellDef="let element" routerLink="/admin/technology/editor" [queryParams]="{id: element.technologyID}">{{ element.sla }}</td>
        </ng-container>

        <!-- Revision Date Column -->
        <ng-container hcColumnDef="revisionDate">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="revisionDateHeader">Revision Date</th>
            <td hc-cell *hcCellDef="let element" routerLink="/admin/technology/editor" [queryParams]="{id: element.technologyID}">{{ element.revisionDate | date: 'shortDate' }}</td>
        </ng-container>

        <tr hc-header-row *hcHeaderRowDef="adminTechnologyDisplayedColumns"></tr>
        <tr hc-row *hcRowDef="let row; columns: adminTechnologyDisplayedColumns"></tr>
    </table>

    <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
        <span class="hc-empty-table-block-ico hc-empty-ico"></span>
        <span class="hc-empty-table-block-msg">No technology items meet your search criteria.</span>
    </div>

    <hc-pagination [length]="adminTechnologyListLength" [pageSize]="adminTechnologyPageSize"
        [hidden]="loadError || loading"></hc-pagination>
</div>